module.exports = fox._r("fonts/woodfordbourne-regular-webfont.svg", __webpack_public_path__ + "fonts/woodfordbourne-regular-webfont.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/woodfordbourne-regular-webfont.svg
// module id = 11
// module chunks = 5